export default __webpack_public_path__ + "static/media/complete-organics-munich.53bf2b4e.png";